import { Controller, useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";

import { Answer, possibleAnswers } from "./Feedback";
import FormGroup from "../../common/components/form/FormGroup";
import FeedbackAnswerRating from "./FeedbackAnswerRating";

interface FeedbackFormProps {
  question: string;
  onSubmit: (answer: Answer) => Promise<void>;
}

export default function FeedbackForm(props: FeedbackFormProps) {
  const {
    control,
    setValue,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Answer>();
  const watchedLabel = watch("label");

  const onSubmit = async (data: Answer) => {
    await props.onSubmit(data);
  };

  return (
    <form className="pt-4" onSubmit={handleSubmit(onSubmit)}>
      <FormGroup label={props.question} errorMessage={errors.value?.message}>
        <Controller
          name="value"
          control={control}
          rules={{ required: "Te rugam sa alegi o nota" }}
          render={({ field }) => (
            <FeedbackAnswerRating
              className="pt-4"
              size="large"
              value={field.value}
              onChange={(e) => {
                field.onChange(e);
                setValue("label", possibleAnswers.find((answer) => answer.value === e)!.label);
              }}
            />
          )}
        ></Controller>
        {watchedLabel && <span className="text-lg pt-2">{watchedLabel}</span>}
      </FormGroup>
      <FormGroup className="pt-2" label="Ne-ar placea sa aflam cateva ganduri despre experienta ta">
        <Controller
          name="description"
          control={control}
          render={({ field }) => (
            <InputTextarea value={field.value} onChange={(e) => field.onChange(e.target.value)} rows={4} style={{ resize: "none" }} />
          )}
        ></Controller>
      </FormGroup>
      <Button type="submit" className="block ml-auto" label="Trimite" icon="pi pi-send" />
    </form>
  );
}
